export default async function jobPoller(
    pollFn,
    checkFn,
    { interval = 3000, maxDuration = 150000 } = {}
    ) {
    try {
        let pollDuration = 0;
        let result = await pollFn();

        while (pollDuration < maxDuration) {
            if (checkFn(result)) {
                return { status: true, data: result };
            }

            await new Promise((resolve) => setTimeout(resolve, interval));
            pollDuration += interval;

            result = await pollFn();
        }

        return {
            status: false,
            errMsg: "Polling timed out",
            data: result,
        };
    } catch (err) {
        return { status: false, errMsg: err.message };
    }
}
